import getEnvironDomain from "ati-utils/getEnvironDomain";

// hostname with port if it exists
const getEnvironDomainHost = () => {
  const domain = getEnvironDomain();

  return process.env.NODE_ENV === "development"
    ? `//${window.location.host}`
    : `//${domain}`;
};

export default getEnvironDomainHost;
